var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3281 0.333984H1.66146C0.928125 0.333984 0.334792 0.933984 0.334792 1.66732L0.328125 13.6673L2.99479 11.0007H12.3281C13.0615 11.0007 13.6615 10.4007 13.6615 9.66732V1.66732C13.6615 0.933984 13.0615 0.333984 12.3281 0.333984ZM2.99479 5.00065H10.9948V6.33398H2.99479V5.00065ZM8.32812 8.33398H2.99479V7.00065H8.32812V8.33398ZM10.9948 4.33398H2.99479V3.00065H10.9948V4.33398Z",
    fill: "#F5B309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/discussion.e2d9a3c88a56b4bedeaa473a6a9d3ecf.svg";
export { ForwardRef as ReactComponent };